import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
  TeamsError,
  TeamAddRequested, 
  TeamAddSuccess, 
  TeamUpdateRequested, 
  TeamUpdateSuccess, 
  TeamDeleteRequested, 
  TeamDeleteSuccess, 
  TeamsRequested,
  TeamsLoaded
} from './teams.actions';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { IAppState } from '../app.state';
import { of } from 'rxjs';
import { UserService } from "../../@core/data/user/user.service";
import { ToastrConfigs } from "../../@core/data/toastr-config";
import { NbToastrService } from "@nebular/theme";

@Injectable()
export class TeamsEffects {
  constructor(
    private actions$: Actions,
    private store: Store<IAppState>,
    private toastrService: NbToastrService,
    private userService: UserService
  ) { }

  addTeam$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TeamAddRequested),
      mergeMap(({ formData, userId }) =>
        this.userService.saveTeam(formData, userId).pipe(
          // TODO Alex: I added users as empty array onyl to solve compilation error. Must be removed
          map((response: any) => TeamAddSuccess({ team: { ...formData, id: response.data }, users: [] })),
          tap(() => this.toastrService.show('Echipă adăugată cu success!', 'Success', ToastrConfigs.success)),
          catchError(() => of(TeamsError()))
        )
      )
    )
  );

  updateTeam$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TeamUpdateRequested),
      mergeMap(({ formData, userId }) =>
        this.userService.updateTeam(formData, userId).pipe(
          // TODO Alex: I added users as empty array onyl to solve compilation error. Must be removed
          map(() => TeamUpdateSuccess({ team: formData, users: [] })),
          tap(() => this.toastrService.show('Echipă actualizată cu success!', 'Success', ToastrConfigs.success)),
          catchError(() => of(TeamsError()))
        )
      )
    )
  );

  deleteTeam$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TeamDeleteRequested),
      mergeMap(({ teamId }) =>
        this.userService.deleteTeam(teamId).pipe(
          map(() => TeamDeleteSuccess({ teamId })),
          tap(() => this.toastrService.show('Echipă ștearsă cu success!', 'Succes', ToastrConfigs.success)),
          catchError(() => of(TeamsError()))
        )
      )
    )
  );

  requestTeams$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TeamsRequested),
      mergeMap(() =>
        this.userService.getTeams().pipe(
          map((response: any) => TeamsLoaded({ teams: response?.data })),
          catchError((error: any) => of(TeamsError()))
        )
      )
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TeamsError),
        tap(() => {
          this.toastrService.show('A apărut o eroare!', 'Eroare', ToastrConfigs.danger);
        })
      ),
    { dispatch: false }
  );
}
